import { render } from "./CouponSuccess.vue?vue&type=template&id=dd3a8054&scoped=true"
import script from "./CouponSuccess.vue?vue&type=script&lang=js"
export * from "./CouponSuccess.vue?vue&type=script&lang=js"

import "./CouponSuccess.vue?vue&type=style&index=0&id=dd3a8054&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd3a8054"]])

export default __exports__